import sci35 from "./Sci35 2.png"
import sci68 from "./Sci68 2.png"
import sci4bio from "./Sci4Bio_new.png"
import sci4ess from "./Sci4ESS 2.png"
import stemsims from "./STEM Sims logo3.jpeg"
import eSci21 from "./eSci21 2.png"
import homeschool from "./homeschool logo2.jpeg"
import masteryLoop from "./mastery loop 3.png"
import styles from "./Products.module.scss"
import { useRef } from "react"
import { useParams } from "react-router"


const Product = () => {
    const { productName } = useParams()
  return (
  <>
    <h1>Product!</h1>
    <h2>{`${productName}`}</h2>
  </>
  )
}

export default Product
